import styled from "styled-components"

export const StyledCopyright = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.extraSmall};
  color: ${({ theme }) => theme.colors.gray};
`
